<template>
  <div class="forbidden-page">
    <h2>403 无权访问</h2>
    <p>你没有访问该页面的权限。如需申请,请联系管理员在「系统管理 - 角色管理」中授权。</p>
    <el-button type="primary" @click="goHome">返回首页</el-button>
  </div>
</template>

<script>
export default {
  methods: {
    goHome() {
      this.$router.replace("/client/businessMgmt");
    },
  },
};
</script>

<style scoped>
.forbidden-page {
  padding: 60px;
  text-align: center;
}
</style>
